import { continuousMenus } from "Application/data/sidebar.data.js";
import { batchMenus } from "Application/data/sidebar.data.js";

// scheduling components
const BatchLine = () => import("Modules/manufacturing/scheduling/views/Scheduling");
const BatchProduction = () => import("Modules/manufacturing/scheduling/views/BatchProduction");
const BatchSetting = () => import("Modules/manufacturing/scheduling/views/BatchSetting");

const ContinuousLine = () => import("Modules/manufacturing/scheduling/views/Continuous");
const ContinuousSchedule = () => import("Modules/manufacturing/scheduling/views/ContinuousSchedule");
const ContinuousProduction = () => import("Modules/manufacturing/scheduling/views/ContinuousProduction");
const ContinuousSetting = () => import("Modules/manufacturing/scheduling/views/ContinuousSetting");

const ContinuousProfile = () => import("Modules/manufacturing/work_orders/views/Profile");
const BatchProfile = () => import("Modules/manufacturing/work_orders/views/BatchProfile");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "batch_line/schedule",
            name: "batch_line",
            component: BatchLine,
            meta: {
                requiresAuth: true,
                title: "lang.batch_line",
                menu: batchMenus,
                restrict_by_login_type: ["employee"],
            },
        },
        {
            path: "batch_line/setting",
            name: "batch_line_setting",
            component: BatchSetting,
            meta: {
                requiresAuth: true,
                title: "lang.setting",
                menu: batchMenus,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["scheduling.read"],
            },
        },
        {
            path: "continuous/schedule",
            name: "continuous_schedule",
            component: ContinuousSchedule,
            meta: {
                requiresAuth: true,
                title: "lang.continuous_schedule",
                menu: continuousMenus,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["scheduling.read"],
            },
        },
        {
            path: "continuous/production",
            name: "continuous_production",
            component: ContinuousProduction,
            meta: {
                requiresAuth: true,
                title: "lang.continuous_production",
                menu: continuousMenus,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["scheduling.read"],
            },
        },
        {
            path: "continuous/setting",
            name: "continuous_setting",
            component: ContinuousSetting,
            meta: {
                requiresAuth: true,
                title: "lang.setting",
                menu: continuousMenus,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["scheduling.read"],
            },
        },
        {
            path: "continuous/production/:work_order_id(\\d+)/batches/:batch_id(\\d+)",
            name: "batch_profile",
            component: ContinuousProfile,
            meta: {
                requiresAuth: true,
                title: "lang.continuous_batch",
                menu: continuousMenus,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["batch.read"],
            },
        },
        {
            path: "batch_line/production/:work_order_id(\\d+)/batches/:batch_id(\\d+)",
            name: "batch_line_profile",
            component: BatchProfile,
            meta: {
                requiresAuth: true,
                title: "lang.continuous_batch",
                menu: batchMenus,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["batch.read"],
            },
        },
        {
            path: "batch_line/production",
            name: "batch_line_production",
            component: BatchProduction,
            meta: {
                requiresAuth: true,
                title: "lang.continuous_production",
                menu: batchMenus,
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["scheduling.read"],
            },
        },
        // {
        //     path: 'continuous_line',
        //     name: 'continuous_line',
        //     component: ContinuousLine,
        //     meta: {
        //         requiresAuth: true,
        //         title: 'lang.continuous_line',
        //     }
        // },
    ],
};
